import { gql } from '@apollo/client';

export const Page = gql(`
    fragment Page on PageRecord {
        __typename
        title
        slug
    }
`);
